<div class="flex min-h-screen flex-col">
    <div class="bg-white py-12 sm:py-12 flex flex-row justify-center items-center">
        <div class="mx-auto max-w-4xl px-6 max-lg:text-center lg:max-w-7xl lg:px-8">
            <img class="mx-auto h-16 w-auto" src="assets/shout_logo_blue.png" alt="SHOUT">
            <p
                class="mt-4 max-w-2xl text-pretty mx-auto t text-lg font-medium text-gray-600 max-lg:mx-auto sm:text-xl/8">
                    Log in to Instagram</p>
        </div>

    </div>

    <div class="relative isolate overflow-hidden bg-white border-2 border-red-500">
        <div class="mx-auto px-6 pb-24 sm:pb-32 lg:flex lg:px-8">


            <script>
                window.fbAsyncInit = function () {
                    FB.init({
                        appId: '783668520102368',
                        cookie: true,
                        xfbml: true,
                        version: 'v22.0'
                    });

                    FB.AppEvents.logPageView();

                };

                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) { return; }
                    js = d.createElement(s); js.id = id;
                    js.src = "https://connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
            </script>

        </div>
    </div>
</div>